import io from 'socket.io-client';

let socket = null;
let session_id = null;
let streamTarget = null;

let wshost = 'https://bugzilla.intellicar.in:10320';
const get = (key) => {
    let data = localStorage.getItem(key);
    try{
        data = JSON.parse(data);
    } catch (e) {
        // Parsing Failed
    }
    return data;
};

const save = (key, data = "") => {
    try{
        data = JSON.stringify(data);
    } catch (e) {
        // Stringify Failed
    }
    localStorage.setItem(key, data);
};

 
 /**
  * 
  * General
  * 
  */

window.intAnalytics = window.intAnalytics || {
    apiFired: {}
};

const onSocketConnect = () => {
    let nav = navigator || {};
    if (socket) {
        socket.emit('startsession', {
            platform: nav.platform,
            deviceMemory: nav.deviceMemory,
            hardwareConcurrency: nav.hardwareConcurrency,
            language: nav.language,
            userAgent: nav.userAgent,
            screen_size_height: window.innerHeight,
            screen_size_width: window.innerWidth,
            appid: this.appid,
            session_start: getTime(),
            browser_uuid: (window.browser_uuid||{uuid:parseInt(Math.random() * 10000)}).uuid 
        });
        if(this.lastPageView) {
            socket.emit('pageview', this.lastPageView);
        }
        if(this.lastSessionLog) {
            socket.emit('sessionlog', this.lastSessionLog);
        }
    }
}

const apiFiredResp = msg => {
    window.intAnalytics.apiFired[msg.uuid] = msg;
}

const subscribeRTLogs =msg=> {
    if(msg && msg.subscribe) {
        window.intAnalytics.realtimeLogs = true;
        sendToServer(consoleHistory || [])
    } else {
        window.intAnalytics.realtimeLogs = false;
    }
}

const onSessionStartSucess =msg=> {
    session_id = msg.session_id;
}

function MouseCursor () {
    this.cursor = document.createElement("DIV");
    this.cursor.className = 'intCursor';
    let styles = {
        position: 'fixed',
        background:'red',
        width: '6px',
        height: '6px',
        top:'-100px',
        left:'-100px',
        zIndex: 10000000000000,
        borderRadius: '100%',
        opacity: 0.6,
        pointerEvents: 'none',
        transition:'0.02s linear'
    }
    for(let key in styles) {
        this.cursor.style[key] = styles[key];
    }


    this.cursorClick = document.createElement("DIV");
    this.cursor.className = 'intCursorClick';
    styles = {
        position: 'absolute',
        background:'red',
        top: '50%',
        left: '50%',
        width: '70px',
        height: '70px',
        marginTop: '-35px',
        marginLeft: '-35px',
        borderRadius: '100%',
        transform: 'scale(0)',
        transition: '0s',
        opacity: 0.6,
    }
    for(let key in styles) {
        this.cursorClick.style[key] = styles[key];
    }
    
    this.cursor.appendChild(this.cursorClick);
    document.body.appendChild(this.cursor);

    this.hide =()=> {
        this.cursor.style.left = '-100px';
        this.cursor.style.top = '-100px';
    }

    this.click =()=> {
        this.cursorClick.style.transform = 'scale(1)';
        this.cursorClick.style.transition = '0.3s';
        this.cursorClick.style.opacity = 0;
        clearTimeout(this.cursorClickTimeout);
        this.cursorClickTimeout = setTimeout(()=> {
            this.cursorClick.style.transition = '0s';
            this.cursorClick.style.opacity = 0.6;
            this.cursorClick.style.transform = 'scale(0)';
        }, 300)
    }

    this.setPosition =pos=> {
        this.cursor.style.left = (pos.x - 3) + 'px';
        this.cursor.style.top = (pos.y - 3) + 'px';
        this.cursor.style.opacity = 1;
        clearTimeout(this.cursorClearTimeout);
        this.cursorClearTimeout = setTimeout(()=> {
            this.cursor.style.opacity = 0;
        }, 5000);
    }
} 

let mouseCursor;

const initialize = appid => {


    // /**
    //  *  UUID
    //  */

    // let browser_uuid = get(appid + '-' + 'browser_uuid');
    // if(!browser_uuid){ // || (browser_uuid.created_at - Date.now()) > 1000 * 60 * 60 * 24 * 7) {
    //     browser_uuid = {
    //         created_at: Date.now(),
    //         uuid: [1,1,1].map(()=>parseInt(Date.now() * Math.random())).join('-')
    //     }
    //     save(appid + '-' + 'browser_uuid', browser_uuid)
    // }
    // window.browser_uuid = browser_uuid;

    // console.log('BROWSER UUID', window.browser_uuid.uuid)

    // /**
    //  *  GENERAL
    //  */
    //  window.mytimer;
    // socket = io.connect(wshost, {
    //     transports: ['websocket', 'polling']
    // });
    // socket.on('connect', onSocketConnect);
    // socket.on('apifired_data', apiFiredResp);
    // socket.on('refresh', () => {
    //     window.location.reload()
    // });

    // socket.on('refreshwithTime', (time, message) => {
    //     var popTimer = document.createElement("div");
    //     var btnClose = document.createElement("i");
    //     var spanCon = document.createElement("span");
    //     popTimer.id = "popTime";
    //     var cont = document.createElement("div");
    //     popTimer.className = "popTimer";
    //     cont.className = "popContent";
    //     popTimer.appendChild(cont);        
    //     spanCon.className = "spanCon";
    //     spanCon.id = "timecont";
    //     spanCon.innerHTML = message + "" + time + "s";
    //     btnClose.className = "fa fa-times-circle";
    //     btnClose.className += " btnClose";
    //     btnClose.onclick = function () {
    //         let self = this;

    //         closeTimer();
    //     }
    //     cont.appendChild(spanCon);
    //     cont.appendChild(btnClose);

    //     var seconds = time;
    //     document.body.appendChild(popTimer);
    //     window.mytimer = setInterval(function () {
    //         seconds = seconds - 1;
    //         document.getElementById("timecont").innerHTML = message + " " + seconds + "s ";

    //         if (seconds == 0) {
    //             clearInterval(window.mytimer);
    //             document.getElementById("timecont").innerHTML = "refreshing..";

    //             window.location.reload()

    //         }
    //     }, 1000);

    // });


    // socket.on('runjs', str => eval(str));
    // socket.on('subrtlog', subscribeRTLogs);
    // socket.on('webrtc', onWebRTC);
    // socket.on('webrtc_controls', onWebRTCControls);
    // socket.on('sessionstartsuccess', onSessionStartSucess);
    // socket.on('heartbeat', () => socket.emit('heartbeat'));
    // logSession();
    // this.appid = appid;

    // mouseCursor = new MouseCursor();
}




/** Closing Timer */
const closeTimer = () => {
    clearInterval(window.mytimer)
    var cTimer = document.getElementById('popTime');
    cTimer.style.display = "none";
}

/*** */
const timezoneOffset = new Date().getTimezoneOffset();

const getTime = () => Date.now() + timezoneOffset;

const pageView = args => {
    if (socket) {
        this.lastPageView = {
            page_id: args.page_id,
            time: getTime()
        };
        socket.emit('pageview', this.lastPageView);
    }
}

const getUUID = () => Date.now() + '-' + (Math.random() * Date.now()) + '-' + (Math.random() * Date.now());

const getAPIID = uuid => {
    return (window.intAnalytics.apiFired[uuid] || {}).api_id
};

const apiFired = args => {
    let uuid = getUUID();
    if (socket) {
        socket.emit('apifired', {
            name: args.name,
            uuid: uuid,
            fired_at: getTime()
        })
    }
    return args => {
        if (socket) {
            socket.emit('apiresponded', {
                api_id: getAPIID(uuid),
                status: args.status,
                responded_at: getTime()
            })
        }
    }
}

const saveLocation = () => {
    navigator.geolocation.getCurrentPosition(location => {
        window.intAnalytics.lat = location.coords.latitude;
        window.intAnalytics.lng = location.coords.longitude;
        logSession();
    }, () => {
        console.warn("Failed to fetch location")
    }, {})
}

const logSession = () => {
    if (socket) {
        this.lastSessionLog = {
            page_active: window.intAnalytics.page_active,
            time: getTime(),
            username: window.intAnalytics.username,
            lat: window.intAnalytics.lat || null,
            lng: window.intAnalytics.lng || null,
            meta: {
                dev: window.location.href.indexOf("localhost") !== -1,
                tabMemory: {...console.memory},
            }
        }
        socket.emit('sessionlog', this.lastSessionLog);

    }
}

const authenticate = args => {
    window.intAnalytics.username = args.username;
    logSession();
}


(function () {
    var hidden = "hidden";

    // Standards:
    if (hidden in document)
        document.addEventListener("visibilitychange", onchange);
    else if ((hidden = "mozHidden") in document)
        document.addEventListener("mozvisibilitychange", onchange);
    else if ((hidden = "webkitHidden") in document)
        document.addEventListener("webkitvisibilitychange", onchange);
    else if ((hidden = "msHidden") in document)
        document.addEventListener("msvisibilitychange", onchange);
    // IE 9 and lower:
    else if ("onfocusin" in document)
        document.onfocusin = document.onfocusout = onchange;
    // All others:
    else
        window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;

    function onchange(evt) {
        var v = "visible",
            h = "hidden",
            evtMap = {
                focus: v,
                focusin: v,
                pageshow: v,
                blur: h,
                focusout: h,
                pagehide: h
            };

        evt = evt || window.event;
        if (evt.type in evtMap) {
            window.intAnalytics.page_active = evtMap[evt.type] === 'visible' ? true : false;
        } else {
            window.intAnalytics.page_active = this[hidden];
        }
        logSession();
    }

    // set the initial state (but only if browser supports the Page Visibility API)
    if (document[hidden] !== undefined)
        onchange({
            type: document[hidden] ? "blur" : "focus"
        });
})();

/**
 * 
 *    Cloning console
 * 
 */

const consoleHistory = [];
const historyLimit = 1000;
const tracing = (args, type) => {
    let data = [];
    for (let idx in args) {
        data.push(args[idx]);
    }
    let log = {log: data, type: type}
    consoleHistory.push(log);
    if (consoleHistory.length > historyLimit) {
        consoleHistory.shift();
    }
    sendToServer([log]);
}
let tempConsole = {};
for (let idx in console) {
    if (typeof console[idx] === 'function') {
        tempConsole[idx] = console[idx];
    }
}

const sendToServer =logs=> {
    if(window.intAnalytics.realtimeLogs) {
        let data = [];
        for(let idx in logs) {
            try {
                JSON.stringify(logs[idx]);
                data.push(logs[idx]);
            } catch (e) {
                let tempLog = [logs[idx].type + ' with circular structure, Failed to convert it to string'];
                data.push({log: tempLog, type: tempLog.type})
            }
        }
        socket.emit('rtlog', data);
    }
}

const cloneConsole = function (key = null) {
    if (key !== null && key in tempConsole) {
        console[key] = function () {
            tracing(arguments, key);
            console[key] = Function.prototype.bind.call(tempConsole[key], console);
            console[key].apply(console, arguments);
            cloneConsole(key);
        };
    } else if (key === null) {
        for (let idx in tempConsole) {
            console[idx] = function () {
                tracing(arguments, idx);
                console[idx] = Function.prototype.bind.call(tempConsole[idx], console);
                console[idx].apply(console, arguments);
                cloneConsole(idx);
            };
        }
    }
}

if((window.location.hostname || '').indexOf('localhost') === -1) {
    cloneConsole();
}

window.onerror = function(error, url, line) {
    tracing([error, url, line], 'newError');
}; 



/**
* 
*  Screen Sharing
* 
*/

let localStream = null;
let peerConnection = null;
let preCloseReq;

const sendScreenConfig =()=> {
    if(localStream && streamTarget) {
        socket.emit('webrtc', {
            event: 'screenConfig',
            targetSocketID: streamTarget,
            data: {
                screenHeight: window.innerHeight,
                screenWidth: window.innerWidth 
            }
        })
    }
}
window.addEventListener('resize', sendScreenConfig);

const startScreenSharing =(msg)=> { 
    streamTarget = msg.sourceSocketID;
    if(navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
        navigator.mediaDevices.getDisplayMedia({ audio: false, video: true })
            .then(stream=>{
                if(preCloseReq)
                    return;

                // stream.getTracks()[0].applyConstraints({frameRate: 5});
                stream.oninactive = function () {
                    localStream = null;
                };
                localStream = stream;
                sendScreenConfig();
                makeOffer(msg);
            })
            .catch(e=>console.log(e));
    }
}

const onWebRTC =msg=> {
    if(msg.event === 'startstream') {
        preCloseReq = false;
        startScreenSharing(msg);
    } else 
    if(msg.event === 'answer') {
        acceptAnswer(msg.sdp, msg);
    } else 
    if(msg.event === 'ice' && peerConnection) {
        peerConnection.addIceCandidate(new RTCIceCandidate(msg.ice))
            .catch(errorHandler);
    } else 
    if(msg.event === 'stopstream') {
        if(peerConnection) {
            peerConnection.close();
            peerConnection = null;
            mouseCursor.hide();
        }
        preCloseReq = true;
    }
}

const errorHandler =(error)=> {
    console.log(error);
}

const peerConnectionConfig = {
    'iceServers': [
        {'urls': 'stun:stun.stunprotocol.org:3478'},
        {'urls': 'stun:stun.l.google.com:19302'},
    ]
};

const gotIceCandidate =event=> {
    if(event.candidate != null) {
        socket.emit('webrtc', {
            event: 'ice', 
            ice: event.candidate, 
            targetSocketID: streamTarget            
        });
    }
}

const makeOffer =(msg)=> {
    if(!localStream) {
        console.error('LocalStream Not Available');
        return;
    }

    peerConnection = new RTCPeerConnection(peerConnectionConfig);
    peerConnection.onicecandidate = gotIceCandidate;
    peerConnection.addStream(localStream);
    peerConnection.createOffer().then(description=>{
        peerConnection.setLocalDescription(description).then(()=> {
            socket.emit('webrtc', {
                event:'offer', 
                sdp: peerConnection.localDescription, 
                targetSocketID: streamTarget
            });
        }).catch(errorHandler);
    }).catch(errorHandler);
}

const acceptAnswer =answer=> {
    if(peerConnection) {
        peerConnection
            .setRemoteDescription(new RTCSessionDescription(answer))
            .then(()=> {}).catch(errorHandler);
    } else {
        console.error('PeerConn Not Found');
    }
}


/**
 * 
 *  WebRTC Controls
 * 
 */

const onWebRTCControls =(msg)=> {
    if(msg.event && ['click', 'mouseDown', 'mouseUp', 'mouseMove'].indexOf(msg.event.eventName) !== -1) {
        triggerMouseEvent(msg.event);
    }
    if(msg.event && ['keyDown', 'keyUp', 'keyPress'].indexOf(msg.event.eventName) !== -1) {
        triggerKeyboardEvent(msg.event);
    }
    if(msg.event && ['cmdPaste'].indexOf(msg.event.eventName) !== -1) {
        if(focusedEl) {
            let fVal = focusedEl.value != null ? focusedEl.value : '';
            let pointer = Math.min(fVal.length+1, Math.max(0, (focusedEl.selectionEnd||fVal.length)+((msg.event.text||'')+'')).length);
            let value = fVal
                .substring(0, focusedEl.selectionStart) + (msg.event.text||'') + fVal
                .substring(focusedEl.selectionEnd, fVal.length);     
            focusedEl.setSelectionRange(pointer, pointer)
            setNativeValue(focusedEl, value);
        }
    }
}

function setNativeValue(element, value) {
    const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
    const prototype = Object.getPrototypeOf(element);
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;
    
    if (valueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(element, value);
    } else {
      valueSetter.call(element, value);
    }
    element.dispatchEvent(new Event('input', { bubbles: true }));
}

const triggerKeyboardEvent =event=> {
    // let keyboardEvent = document.createEvent("KeyboardEvent");
    // let initMethod = typeof keyboardEvent.initKeyboardEvent !== 'undefined' ? "initKeyboardEvent" : "initKeyEvent";

    // keyboardEvent[initMethod](
    //     event.eventName.toLowerCase(), // event type : keydown, keyup, keypress
    //     true, // bubbles
    //     true, // cancelable
    //     window, // viewArg: should be window
    //     event.ctrlKey, // ctrlKeyArg
    //     event.altKey, // altKeyArg
    //     event.shitKey, // shiftKeyArg
    //     event.metaKey, // metaKeyArg
    //     event.keyCode, // keyCodeArg : unsigned long the virtual key code, else 0
    //     event.keyCode // charCodeArgs : unsigned long the Unicode character associated with the depressed key, else 0
    // );
    // document.dispatchEvent(keyboardEvent);

    if(focusedEl) { 
        let fVal = focusedEl.value != null ? focusedEl.value : '';
        if(event.ctrlKey && event.keyCode === 65) { 
            focusedEl.setSelectionRange(0, focusedEl.value.length)
        } 
        else if(!event.ctrlKey) {
            if(focusedEl.tagName === 'SELECT' && (event.keyCode === 38 || event.keyCode === 40) && focusedEl.children) {
                let options = [];
                let currentIndex = -1;
                for(let idx=0; idx < focusedEl.children.length; idx++) {
                    if(focusedEl.value === focusedEl.children[idx].value) {
                        currentIndex = idx;
                    }
                    options.push(focusedEl.children[idx].value)
                }
                if((event.keyCode === 38 && currentIndex > 0) || (event.keyCode === 40 && currentIndex < options.length-1)) {
                    focusedEl.value = options[currentIndex + (event.keyCode === 38 ? -1 : 1)];
                } else if(currentIndex === -1 && options[0]) {
                    focusedEl.value = options[0];
                }
            } else if(scrollableEl && focusedEl.tagName !== 'INPUT'  && (event.keyCode === 38 || event.keyCode === 40)) {
                let scrollTop = 0;
                if(event.keyCode === 38) {
                    scrollTop = Math.max(0, scrollableEl.scrollTop - 10);
                } else {
                    scrollTop = scrollableEl.scrollTop + 10;
                }
                scrollableEl.scrollTop = scrollTop;
            }
            if(focusedEl.selectionStart !== focusedEl.selectionEnd) { // If the input has selection
                if(event.key.length === 1) {
                    let value = fVal
                        .substring(0, focusedEl.selectionStart) + event.key + fVal
                        .substring(focusedEl.selectionEnd, fVal.length);
                    setNativeValue(focusedEl, value);
                } else if(event.keyCode === 37 || event.keyCode === 38) {
                    focusedEl.setSelectionRange(focusedEl.selectionStart, focusedEl.selectionStart)
                } else if(event.keyCode === 39 || event.keyCode === 40) {
                    focusedEl.setSelectionRange(focusedEl.selectionEnd, focusedEl.selectionEnd)
                } else if(event.keyCode === 8 || event.keyCode === 46) {
                    let value = fVal
                        .substring(0, focusedEl.selectionStart) + fVal
                        .substring(focusedEl.selectionEnd, fVal.length);
                    setNativeValue(focusedEl, value);
                }
            } else {
                if(event.key.length === 1) {
                    let pointer = Math.min(fVal.length+1, Math.max(0, (focusedEl.selectionEnd||fVal.length)+1));
                    let value = fVal
                        .substring(0, focusedEl.selectionStart) + event.key + fVal
                        .substring(focusedEl.selectionEnd, fVal.length);     
                    focusedEl.setSelectionRange(pointer, pointer)

                    setNativeValue(focusedEl, value);
                } else if (event.keyCode === 37) {
                    let pointer = Math.min(fVal.length, Math.max(0, (focusedEl.selectionStart||0)-1));
                    focusedEl.setSelectionRange(pointer, pointer)
                } else if (event.keyCode === 39) {                    
                    let pointer = Math.min(fVal.length, Math.max(0, (focusedEl.selectionEnd||fVal.length)+1));
                    focusedEl.setSelectionRange(pointer, pointer)
                } else if (event.keyCode === 8) { 
                    let value = fVal
                        .substring(0, focusedEl.selectionStart-1) + fVal
                        .substring(focusedEl.selectionEnd, fVal.length);
                    setNativeValue(focusedEl, value);

                } else if (event.keyCode === 46) {
                    let value = fVal
                        .substring(0, focusedEl.selectionStart) + fVal
                        .substring(focusedEl.selectionEnd+1, fVal.length);
                    setNativeValue(focusedEl, value);

                }
            }
        } 
    }
}

const findScrollableEl =el=> {
    if(!getComputedStyle) 
        return;

    let style = getComputedStyle(el);
    let isScrollable = style['overflow-y'] == 'scroll' || style['overflow-y'] == 'auto' || style['overflow'] == 'scroll' || style['overflow'] == 'auto';
    if(isScrollable) {
        scrollableEl = el;
    } else if(el.parentElement) {
        findScrollableEl(el.parentElement);
    } else {
        scrollableEl = null;
    }
}

let scrollableEl = null;
let focusedEl = null;

const triggerMouseEvent =(event)=> {
    let el = document.elementFromPoint(event.x, event.y);
    if(!el)
        return;

    el.dispatchEvent(new MouseEvent(event.eventName.toLowerCase(), {
        'view': window,
        'bubbles': true,
        'button': event.button,
        'cancelable': true,
        'screenX': event.x,
        'screenY': event.y,
        'layerX': event.x,
        'layerY': event.y,
        'clientX': event.x,
        'clientY': event.y,
    }));
    if(event.eventName === 'mouseMove' && mouseCursor) {
        mouseCursor.setPosition(event);
        clearTimeout(this.mouseMoveDeBounce);
        this.mouseMoveDeBounce = setTimeout(()=> {
            findScrollableEl(el.parentElement);
        }, 500)
    }
    if(event.eventName === 'click') {
        mouseCursor.click();
    }
    if(event.eventName === 'mouseUp' && el.focus) {
        el.focus();
        focusedEl = el;
        findScrollableEl(el);
    } else if(event.eventName === 'mouseUp') {
        focusedEl = null;
    }
}



export default {
    onSocketConnect,
    initialize,
    pageView,
    saveLocation,
    logSession,
    apiFired,
    authenticate
}
